<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.contractName}}</span>
        </el-col>
        <el-col :span="8" align="right">
          <el-button v-if="detail.id" type="text" @click="handleAssign()">分配</el-button>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户名称</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同总金额</div>
          <div class="value">{{amountFormat(detail.contractTotalAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">计划期次</div>
          <div class="value">{{detail.planFundBatch}}</div>
        </div>
        <div class="base-item">
          <div class="title label">计划回款</div>
          <div class="value">{{amountFormat(detail.planFundAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">回款状态</div>
          <div class="value">{{detail.planFundStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">实际回款</div>
          <div class="value">{{amountFormat(detail.actualAmount)}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进记录" name="follow">
              <FollowAdd :targetId="detail.id" targetType="contractPlanFund" @success="handleAfterFollowAdd"></FollowAdd>
              <div style="height: 473px">
                <FollowList :targetId="detail.id" targetType="contractPlanFund" ref="followListRef"></FollowList>
              </div>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="110px" :hide-required-asterisk="!editModel">
                <el-row :gutter="20" align="left">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="合同名称:">
                      <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail()">{{detail.contractName}}</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户名称:">
                      <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="合同总金额:">
                      <span class="value">{{amountFormat(detail.contractTotalAmount)}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="计划期次:">
                      <span class="value">{{detail.planFundBatch}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="本期比例:" prop="planFundRate">
                      <el-input-number
                        v-if="editModel"
                        v-model="updateData.planFundRate"
                        placeholder="请输入本期比例"
                        :min="0"
                        :max="100"
                        :precision="2"
                        :controls="false"
                        clearable
                        class="crm-input-number-wrap"
                        @change="planFundRateChange"
                      />
                      <span v-if="editModel" class="el-input__suffix">%</span>
                      <span v-if="!editModel" class="value">{{detail.planFundRate}}%</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="计划回款:" prop="planFundAmount">
                      <el-input-number
                        v-if="editModel"
                        v-model="updateData.planFundAmount"
                        placeholder="请输入计划回款金额"
                        :min="0"
                        :max="detail.contractTotalAmount"
                        :precision="2"
                        :controls="false"
                        clearable
                        class="crm-input-number-wrap"
                        @change="planFundAmountChange"
                      />
                      <span v-if="editModel" class="el-input__suffix">元</span>
                      <span v-if="!editModel" class="value">{{amountFormat(detail.planFundAmount)}}元</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="计划回款日期:" prop="planFundDate">
                      <el-date-picker v-if="editModel" v-model="updateData.planFundDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                      <span v-else class="value">{{detail.planFundDate}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建人:">
                      <span class="value">{{detail.createUserName}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建时间:">
                      <span class="value">{{detail.createTime}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="'回款记录(' + contractFundRecordCount + ')'" name="contractFundRecord">
              <FundRecordList ref="fundRecordListRef" :contractPlanFundId="detail.id" height="630" @after-query="handleAfterFundRecordQuery"></FundRecordList>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.manager ? detail.manager.managerAvatar : ''" :name="detail.manager ? detail.manager.managerName : ''"/>
            <div class="name"><span class="value">{{detail.manager ? detail.manager.managerName : ""}}</span></div>
          </div>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="contractPlanFund"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import OperateLogList from "@/views/crm/components/operateLogList";
import AssignDialog from "@/views/crm/components/assignDialog";
import UserAvatar from '@/views/system/user/userAvatar'
import FundRecordList from "@/views/crm/fundRecord/fundRecordList";
import { amountFormat } from '@/utils/index'
import {queryContractPlanFundDetail, updateContractPlanFund} from "@/api/crm/planFund";

export default {
  name: "PlanFundDetail",
  data() {
    return {
      // 遮罩层
      amountFormat,
      loading: true,
      detail: {},
      activeName: "follow",
      editModel: false,
      contractFundRecordCount: 0,
      updateData: {
        id: null,
        planFundAmount: undefined,
        planFundRate: undefined,
        planFundDate: null,
      },
      updateRules: {
        planFundAmount: [
          {required: true, type:'number', message: '请输入计划回款金额', trigger: 'blur'}
        ]
      },
    };
  },
  components: {
    FollowList,
    FollowAdd,
    OperateLogList,
    AssignDialog,
    FundRecordList,
    UserAvatar,
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的合同");
    }
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'contractFundRecord') {
        this.$refs.fundRecordListRef.queryList()
      }
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryContractPlanFundDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
          if (response.data.contractTotalAmount) {
            let planFundRate = response.data.planFundAmount / response.data.contractTotalAmount * 100;
            this.detail.planFundRate = planFundRate.toFixed(2);
          }
        } else {
          this.msgError("查询不到此回款计划");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    planFundRateChange (currentValue, oldValue) {
      console.log('planFundRateChange', currentValue, oldValue);
      if (this.detail.contractTotalAmount) {
        this.updateData.planFundAmount = this.detail.contractTotalAmount * currentValue / 100;
      }
    },
    planFundAmountChange (currentValue, oldValue) {
      console.log('planFundAmountChange', currentValue, oldValue);
      if (this.detail.contractTotalAmount) {
        this.updateData.planFundRate = currentValue / this.detail.contractTotalAmount * 100;
      }
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleAfterFundRecordQuery (list) {
      this.contractFundRecordCount = list.length;
    },
    handleEdit () {
      this.updateData.id = this.detail.id;
      this.updateData.planFundAmount = this.detail.planFundAmount;
      this.updateData.planFundDate = this.detail.planFundDate;
      this.updateData.planFundRate = this.detail.planFundRate;
      this.editModel = true
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          updateContractPlanFund(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 详细按钮操作 */
    toContractDetail() {
      this.$router.push("/crm/contract/detail/" + this.detail.contractId);
    },
    /** 详细按钮操作 */
    toCustomerDetail() {
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("contractPlanFund", this.detail.id)
    }
  }
};
</script>
